//@author: mandy
import { S25Util } from "../../../util/s25-util";

export class S25Durationfilter {
    public static duration(duration: any) {
        return S25Util ? S25Util.ISODurationToStr(duration) : "";
    }
}
